import { IFullPlanDetail } from "../../../interfaces/api";
import SingleInfoBenefit from "./SingleInfoBenefit.component";
import { getDoubleDeepHMO } from "../../../functions/planDetails";

const DataTableDetailVision = ({ data }: { data: IFullPlanDetail }) => {
  const eyeExamsBenefit = getDoubleDeepHMO(
    data,
    "Vision Services",
    "Eye Exams (Medicare and Routine)"
  );
  const eyeEyewearBenefits = getDoubleDeepHMO(
    data,
    "Vision Services",
    "Eyewear"
  );
  return (
    <div
      className="grid-x"
      style={{
        backgroundColor: "white",
        border: "1px solid #D3E1F0",
        textAlign: "left",
      }}
    >
      <SingleInfoBenefit benefit={eyeExamsBenefit} title="Eye Exams" />
      <SingleInfoBenefit benefit={eyeEyewearBenefits} title="Eyewear" />
    </div>
  );
};

export default DataTableDetailVision;
